import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { Box, Drawer } from '@material-ui/core';
import AppBar from '../../Components/Header/newIndex';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDashboardCardArray } from '../../Utils/dashboardCards';
import Logo from '../../Assets/ken42-logo.jpg';
import AcademicsPlannerNavigation from '../../Components/SideNavigation/AcademicsPlannerNavigation';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import routes from '../../Utils/routes.json';

import CurrentProgrammes from './CurrentProgrammes/';
import FacultyManagement from './FacultyManagement/';
import SessionScheduler from './TimeTable/';
// import TimeTable from './TimeTable/TimeTable';
import AddProgram from './AddProgram/';
import AddActivity from './AddActivity/';
import ArrowDropDownCircleRounded from '@material-ui/icons/ArrowDropDownCircleRounded';
import ProgramDetails from './ProgramDetails';
import FacultyDetails from './AddProgram/FacultyDetails';
import TimeTable from './TimeTable/TimeTable';
import TimeTableNew from './TimeTableNew/TimeTableNew';

const drawerWidth = 260;
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    background: theme.palette.KenColors.background,
    padding: '0 32px',
    minHeight: '100vh',
    marginTop: 64,
    overflow: 'hidden',
  },
  containerWrap: {
    width: 'calc(100% - 260px)',
  },
  appBar: {
    [theme.breakpoints.up('smUp')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      zIndex: 1000,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerOpen: {
    width: drawerWidth,
    overflow: 'hidden',
    background: '#092682',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.KenColors.kenLogoColor,
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: 65,
    },
    [theme.breakpoints.down('xs')]: {
      width: 65,
    },
  },
  toolbar: theme.mixins.toolbar,
}));

const menus = [
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Home',
    path: routes.academicsPlanner,
  },
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Current Batches',
    path: routes.currentProgrammes,
  },
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Add Program / Batch / Specialization',
    path: routes.addProgram,
  },
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Add Activity',
    path: routes.addActivity,
  },
  // {
  //   icon: <ArrowDropDownCircleRounded />,
  //   label: 'Add Activity',
  //   path: routes.addActivity,
  // },
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Time table',
    path: routes.sessiontimeTable,
  },
  {
    icon: <ArrowDropDownCircleRounded />,
    label: 'Faculty Management',
    path: routes.facultySection,
  },
];

const AcademicsPlanner = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [openDrawer, setOpenDrawer] = useState(true);

  const handleClick = () => {
    history.push('/app/academics-planner');
  };

  return (
    <Box className={classes.mainContainer}>
      <div className={classes.sideNavWrap}>
        <Drawer
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            }),
          }}
          variant="permanent"
          open
        >
          <AcademicsPlannerNavigation
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            menuList={menus}
          />
        </Drawer>
      </div>

      <div className={classes.containerWrap}>
        <AppBar
          logo={Logo}
          title="Academics Planner"
          handleClick={handleClick}
          history={history}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          cards={getDashboardCardArray(t)}
        />
        <Box className={classes.container}>
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <Route exact path={routes.academicsPlanner}>
                <Redirect to={routes.currentProgrammes} />
              </Route>
              <Route exact path={routes.currentProgrammes}>
                <CurrentProgrammes />
              </Route>
              <Route exact path={routes.currentProgramDetails}>
                <ProgramDetails />
              </Route>
              <Route exact path={routes.facultyDetails}>
                <FacultyDetails />
              </Route>
              <Route exact path={routes.addProgram}>
                <AddProgram />
              </Route>

              <Route exact path={routes.addActivity}>
                <AddActivity />
              </Route>
              <Route exact path={routes.sessiontimeTable}>
                <TimeTable />
              </Route>
              <Route exact path={routes.sessiontimeTableNew}>
                <TimeTableNew />
              </Route>
              <Route exact path={routes.facultySection}>
                <FacultyManagement />
              </Route>
            </Switch>
          </Suspense>
        </Box>
      </div>
    </Box>
  );
};

export default AcademicsPlanner;
